import React from "react";
import Layout from "./../components/Layout";
import "../styles/Contact.css";
import Swal from "sweetalert2";
import CardMedia from "@mui/material/CardMedia";
import user from "../assets/images/socialMedia.jpg";

const Contact = () => {
  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);
    formData.append("access_key", "8ecac421-e7f3-42ff-9bbb-c61710a04fd8");
    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();
    if (data.success) {
      Swal.fire({
        title: "Success!",
        text: "Message sent successfully",
        icon: "success",
      });
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <Layout>
      <section className="contact">
        <form onSubmit={onSubmit}>
          <h2>Have questions? Get in touch!</h2>
          <br />
          <div className="input-box">
            {/* <label>Full Name</label> */}
            <input
              type="text"
              className="field"
              placeholder="Full Name *"
              name="name"
              required
            />
          </div>
          <div className="input-box">
            <input
              type="text"
              className="field"
              placeholder="Pet Name *"
              name="pet_name"
              required
            />
          </div>
          <div className="input-box">
            <input
              type="text"
              className="field"
              placeholder="Species (Dog, Cat, Rabbit...) *"
              name="species"
              required
            />
          </div>
          <div className="input-box">
            <input
              type="tel"
              className="field"
              placeholder="WhatsApp Number *"
              name="whatsapp"
              required
            />
          </div>
          <div className="input-box">
            {/* <label>Emai1 Address</label> */}
            <input
              type="email"
              className="field"
              placeholder="Email *"
              name="email"
              required
            />
          </div>
          <div className="input-box">
            {/* < label>Your Message</label> */}
            <textarea
              name="message"
              id=""
              className="field mess"
              placeholder="Message *"
              required
            ></textarea>
          </div>
          <button type="submit">Send Message</button>
        </form>
      </section>

      <div className="venue-location">
        <div className="venue-details">
          {/* <p><span className="icon">📞</span> <a href="tel:+91 9243402873">+91 78993 95226</a></p> */}
          <br />
          <div className="address">
            <h3>Practical Pet Parenting</h3>
            <span className="icon">🏠</span> Chitradurga, Karnataka <br />
            <span className="icon">📧</span>{" "}
            <a href="mailto:hallilabs@gmail.com">
              practicalpetparenting@gmail.com
            </a>
          </div>
        </div>
        <div className="map">
          {/* <iframe id="googlemap"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=en&amp;q=Chitradurga,%20Karnataka+(Practical%20Pet%20Parenting)&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
          </iframe> */}
          <a
            href="https://www.instagram.com/indianpetvet/"
            className="Instagram social"
            target="_blank"
          >
            <CardMedia
              component="img"
              image={user}
              alt="Instagram"
              style={{
                maxWidth: "100%",
                height: "100%",
                marginBottom: "10px",
              }}
            />
          </a>
          <div className="instagram">
            Follow on{" "}
            <a
              href="https://www.instagram.com/indianpetvet/"
              className="Instagram social"
              target="_blank"
            >
              instagram
            </a>{" "}
            for more pet parenting tips!
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Contact;